import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthProviderWithNavigate from './auth/AuthProviderWithNavigate';
import { AUTH_CONFIG } from './auth/authConfig';
import { initializeEntraAuth } from './auth/msalClient';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

async function startApp() {
  if (AUTH_CONFIG.isEntra) {
    await initializeEntraAuth();
  }

  root.render(
    <React.StrictMode>
      <Router>
        <AuthProviderWithNavigate>
          <App />
        </AuthProviderWithNavigate>
      </Router>
    </React.StrictMode>
  );
}

startApp();
